import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

//const {contextData} = useDataContext();
    

export default async function getBotones_gastos(productofolio) {
    

  //console.log(valor);
    const Botones_GastosDB =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Botones_gastos/");
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      Botones_GastosDB.push(doc.data());
    });
    return Botones_GastosDB;
    

}


//"+productofolio+"
